import { useEffect, useState } from "react";
import api from "@/lib/api";

export const INTERVAL_ORDER = ["monthly", "6mo", "12mo"];
export const INTERVAL_LABELS = { monthly: "Monthly", "6mo": "6 Months", "12mo": "12 Months" };

/**
 * Fetch recurring billing options (monthly / 6mo / 12mo) for paid plans.
 * Returns { options: { pro: [...], pm: [...] }, loading }.
 */
export function useBillingOptions() {
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    api.get("/billing/options")
      .then((r) => { if (active) setOptions(r.data); })
      .catch(() => { if (active) setOptions(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  return { options, loading };
}

/** Find a specific option for a plan + interval. */
export function findOption(options, planId, interval) {
  const list = (options && options[planId]) || [];
  return list.find((o) => o.interval === interval) || null;
}

/** Savings % vs the monthly-equivalent price, for a given option. */
export function savingsPct(options, planId, interval) {
  const monthly = findOption(options, planId, "monthly");
  const opt = findOption(options, planId, interval);
  if (!monthly || !opt || interval === "monthly") return 0;
  const pct = Math.round((1 - opt.per_month_equivalent / monthly.amount) * 100);
  return pct > 0 ? pct : 0;
}
